import {
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import React from "react";
import { AppColors } from "../../../utility/AppColors";
import { AppFontStyle } from "../../../styles/AppFontStyle";
import {
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import ModalWrapper from "../../../common/ModalWrapper";

interface InviteOpponentModalProps {
  showModal: boolean;
  setShowModal: (show: boolean) => void;
  selectedOption: (option: "Friends" | "Social") => void;
  challengeDetails?: any;
  onClose?: () => void;
}

export default function InviteOpponentModal(props: InviteOpponentModalProps) {
  const {
    showModal = false,
    setShowModal,
    selectedOption,
    onClose,
  } = props;

  const deviceSize = useDeviceSize();
  const isMobile = deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM;

  const onCloseClick = () => {
    setShowModal(false);
    if (onClose) onClose();
  };

  return (
    <ModalWrapper
      visible={showModal}
      onClose={onCloseClick}
      title="Invite your opponent"
      scrollable={false}
      mobileHeight="auto"
    >
      {/* Description */}
      <Text
        style={[
          isMobile ? AppFontStyle.REGULAR_ANYBODY_14 : AppFontStyle.REGULAR_ANYBODY_16,
          {
            color: "#9CA3AF",
            lineHeight: isMobile ? 20 : 24,
          },
        ]}
      >
        Select your opponent from friend list or from social media
      </Text>

      {/* Separator */}
      <View
        style={{
          height: 1,
          backgroundColor: "#374151",
          width: "100%",
        }}
      />

      {/* Buttons */}
      <View
        style={{
          flexDirection: "row",
          columnGap: 16,
          paddingVertical: isMobile ? 12 : 20,
          width: "100%",
        }}
      >
        <TouchableOpacity
          style={{
            flex: 1,
            backgroundColor: "transparent",
            borderWidth: 1,
            borderColor: AppColors.white,
            paddingHorizontal: 16,
            paddingVertical: 12,
            borderRadius: 8,
            justifyContent: "center",
            alignItems: "center",
          }}
          activeOpacity={0.5}
          onPress={() => selectedOption("Friends")}
        >
          <Text
            style={[
              AppFontStyle.BOLD_ANYBODY_14,
              { color: "#DC2626" },
            ]}
          >
            Friend list
          </Text>
        </TouchableOpacity>

        <TouchableOpacity
          style={{
            flex: 1,
            backgroundColor: "#DC2626",
            paddingHorizontal: 16,
            paddingVertical: 12,
            borderRadius: 8,
            justifyContent: "center",
            alignItems: "center",
          }}
          activeOpacity={0.5}
          onPress={() => selectedOption("Social")}
        >
          <Text
            style={[
              AppFontStyle.BOLD_ANYBODY_14,
              { color: AppColors.white },
            ]}
          >
            Social media
          </Text>
        </TouchableOpacity>
      </View>
    </ModalWrapper>
  );
}
